import React from "react";
import { makeStyles } from "@material-ui/styles";
import { getModuloColor } from '../helpers/constants';
import { Paper, Typography, IconButton, LinearProgress } from "@material-ui/core";





export default function ProjectTag(props) {
  const { title, id } = props;
  const useStyles = makeStyles((theme) => ({
    tag: {
      borderRadius: 3,
      paddingLeft: 5,
      paddingRight: 5,
      flex:"1 1 auto", 
      minWidth: 0,
      maxWidth: "fit-content"
    },
  }));
  const classes = useStyles();


  return (
    <div style={{width: "100%", display:"flex"}}>
      <Typography noWrap variant="body2" style={{ backgroundColor: getModuloColor(id) }} className={classes.tag}>{title}</Typography>
    </div>
  );
}
